// adapted from segment.js in the analytics functions
// inlined here so that we can make a page view call as soon as possible
// in the render process
const segmentInline = (segmentKey: string) => `
  var SEGMENT_METHODS = [
    "trackSubmit",
    "trackClick",
    "trackLink",
    "trackForm",
    "pageview",
    "identify",
    "reset",
    "group",
    "track",
    "ready",
    "alias",
    "debug",
    "page",
    "once",
    "off",
    "on"
  ];
  
  var segment = [];
  window.analytics = segment;
  
  segment.factory = function(method) {
    return function() {
      var args = Array.prototype.slice.call(arguments);
      args.unshift(method);
      segment.push(args);
      return segment;
    };
  };
  
  for (var i = 0; i < SEGMENT_METHODS.length; i++) {
    var key = SEGMENT_METHODS[i];
    segment[key] = segment.factory(key);
  }
  
  segment.load = function(key) {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src =
      ("https:" === document.location.protocol ? "https://" : "http://") +
      "cdn.segment.com/analytics.js/v1/" +
      key +
      "/analytics.min.js";
  
    // Insert our script next to the first script element.
    var first = document.getElementsByTagName("script")[0];
    first.parentNode.insertBefore(script, first);
  };
  
  segment.SNIPPET_VERSION = "4.0.0";
  segment.load("${segmentKey}");
  segment.page();
  
  function isApp(queryParams) {
    var fragments = queryParams && queryParams.match(/app\=(\d+)/);
    if (!fragments) {
      return false;
    }
    return !!fragments[1];
  }
  window.analytics["track"]("page-view", {
    channel: "web",
    app: isApp(window.location.search),
    domain: window.location.host,
    screen: {
      height: window.screen.height,
      width: window.screen.width
    },
    pathname: window.location.pathname,
    search: window.location.search,
    value: "page",
    "homepage-2019-test": "homepage-old-3"
  });
`;

export default segmentInline;
